const preview = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">

<head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <title>Email Preview</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>

<body style="margin: 0; padding: 0;background:#EBEDF4;">
    <table border="0" cellpadding="0" cellspacing="0" width="100%" height="100%" style="background:#EBEDF4;font-family: Helvetica,arial,sans-serif;">
        <tr>
            <td>
                <table width="700px" align="center" cellpadding="0" cellspacing="0">
                    <tr>
                        <td style="padding-top:26px;padding-bottom:16px; text-align:right;font-size:14px;color:#333">
                            Hello {user_name}, Here is your order summary and tickets for
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <img style="width:700px;height:263px" src="{event_image}" alt="{event_name}" />
                        </td>
                    </tr>
                    <tr>
                        <td height="22px" style="font-size:0;line-height:0;">&nbsp;</td>
                    </tr>
                </table>
                <table width="700px" align="center" cellpadding="0" cellspacing="0" style="background:#fff;border-radius:8px;table-layout:fixed;">
                    <tr>
                        <td>
                            <img style="border-radius: 5px; width: 700px;" width="700" src="https://maps.googleapis.com/maps/api/staticmap?scale=1&center={event_point}&amp;markers=icon:https://e.sparxo.com/public/mail/icon-marker-small.png%7C{event_point}&amp;zoom={map_zoom}&amp;size=640x220&amp;maptype=roadmap&amp;key=AIzaSyAfqaGqnLOBVbPK71YZ4r39mpivMnW5gUA&style=feature:water|color:0xE9E9E9&style=feature:landscape|color:0xF5F5F5&style=feature:road|color:0xFFFFFF&style=feature:poi|color:0xF5F5F5&style=feature:transit|color:0xF2F2F2&style=element:labels.text.stroke|color:0xFFFFFF&style=element:labels.text.fill|color:0x999999&style=element:labels.icon|visibility:off" />

                        </td>
                    </tr>
                    <tr>
                        <td style="padding:38px 40px; font-size:32px;text-align:center;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">
                            {event_name}
                        </td>
                    </tr>

                    <tr style="{show_date_and_time_style}">
                        <td align="center" height="100px">
                            <img src="https://nest.sparxo.com/public/mail/icon-clock.png" width="60px" style="width:60px;" />
                        </td>
                    </tr>
                    <tr style="{show_date_and_time_style}">
                        <td align="center" style="font-size:22px;line-height:36px">
                            {event_time}
                        </td>
                    </tr>
                    <tr style="{show_date_and_time_style}">
                        <td>&nbsp;</td>
                    </tr>
                    <tr style="{show_date_and_time_style}">
                        <td>&nbsp;</td>
                    </tr>

                    <tr>
                        <td align="center" height="100px">
                            <img src="https://nest.sparxo.com/public/mail/icon-marker.png" width="60px" style="width:60px;" />
                        </td>
                    </tr>
                    <tr>
                        <td align="center" style="padding:0 40px; font-size:22px;line-height:36px">
                            {event_location}
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td align="center" height="100px">
                            <img src="https://nest.sparxo.com/public/mail/rl.png" width="60px" style="width:60px;" />
                        </td>
                    </tr>
                    <tr>
                        <td align="center" style="font-size:20px;line-height:25px">
                            <table style="width:600px;text-align:center;" align="center" width="600px">
                                <tr>
                                    <td>
                                        <a href="#" style="color:#28abe8;text-decoration:none">Google</a>
                                    </td>
                                    <td>
                                        <a href="#" style="color:#28abe8;text-decoration:none">Outlook</a>
                                    </td>
                                    <td>
                                        <a href="#" style="color:#28abe8;text-decoration:none">iCal</a>
                                    </td>
                                    <td>
                                        <a href="#" style="color:#28abe8;text-decoration:none">Yahoo</a>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                    <tr>
                        <td>&nbsp;</td>
                    </tr>
                </table>

                <table width="100%" cellpadding="0" cellspacing="0">
                    <tr>
                        <td height="22px" style="font-size:0;line-height:0">&nbsp;</td>
                    </tr>
                </table>
                <table width="100%" align="center" cellpadding="0" cellspacing="0" style="background:#78BDE7;
                              background-image: -webkit-radial-gradient(at 25% 0, #7BE6CA 10%,#71a2fe 90%,#6679fa 100%);
                                background-image: -moz-radial-gradient(at 25% 0, #7BE6CA 10%,#71a2fe 90%,#6679fa 100%);
		                        background-image:radial-gradient(at 25% -20%,#7be6ca 10%,#71a2fe 90%,#6679fa 100%);">
                    <tr>
                        <td style="padding:22px">
                            <table width="700px" align="center" cellpadding="0" cellspacing="0" style="background:#fff;border-radius:8px;">
                                <tr>
                                    <td style="padding:24px 40px 20px 40px; font-size:24px;">
                                        A message from {merchant_name}
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding:0px 40px 24px 40px; font-size:14px;">
                                        {email_greeing}
                                    </td>
                                    <td></td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
                <table width="100%" cellpadding="0" cellspacing="0">
                    <tr>
                        <td height="22px" style="font-size:0;line-height:0">&nbsp;</td>
                    </tr>
                </table>
                <table width="700px" align="center" cellpadding="0" cellspacing="0" style="background:#fff;border-radius:8px;">
                    <tr>
                        <td style="padding:24px 35px; font-size:24px;">
                            Got Questions?
                        </td>
                    </tr>
                    <tr>
                        <td style="padding:0px 40px 60px 40px; font-size:14px;">
                            Contact the organizer at: {contact_tel}
                            <br /> {contact_email}
                        </td>
                        <td></td>
                    </tr>
                </table>

            </td>
        </tr>
    </table>
</body>

</html>`;

export default preview;